//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryEnrollType,
  queryNotice,
} from '@/https/user'
import setScrollDomMixinKeepAlive from '@/mixins/setScrollDomMixinKeepAlive'

export default {
  name: 'RNoticeList',

  components: {},

  mixins: [setScrollDomMixinKeepAlive],

  data () {
    return {
      chooseTab: '',
      noticeList: [],
    }
  },

  watch: {
    async chooseTab (val) {
      this.setNotice()
    },
  },

  mounted () {
    this.setNotice()
  },

  methods: {

    async setNotice () {
      const { data } = await queryNotice({ zslbdm: this.chooseTab })
      this.noticeList = data || []
    },

    scrollDom () {
      return document.getElementsByClassName('c-list')[0]
    },

    queryEnrollType,

    goNoticeDetail (notice) {
      this.$router.push({
        path: '/noticeDetail',
        query: { wid: notice.wid },
      })
    },
  },
}
